
export const symptoms = [
    "Persistent bloating and digestive discomfort",
    "Sluggish metabolism and gradual weight gain",
    "Constant cravings for sweets and carbs",
    "Common issues like IBS, constipation, and gut imbalance",
    "Low energy levels and hormonal fluctuations",
  ]


  